import { useState } from "react";

/**
 * Collapsed-by-default disclosure listing the templating variables a user can
 * drop into a subscription delivery's Subject or Body. Same list everywhere —
 * keep this file as the single source of truth.
 */
export function SubscriptionVariablesHelp(props: { target?: "page" | "atlas_report" }): JSX.Element {
  const [open, setOpen] = useState(false);
  const forReport = props.target === "atlas_report";
  return (
    <div style={{ marginTop: 4 }}>
      <button
        type="button"
        className="adminListAction"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        style={{ fontSize: 13 }}
      >
        {open ? "Hide variables" : "Variables you can use"}
      </button>
      {open ? (
        <div
          style={{
            marginTop: 6,
            padding: 10,
            borderRadius: 6,
            background: "var(--panel, #f8fafc)",
            border: "1px solid var(--border)",
            fontSize: 13,
          }}
        >
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {forReport ? (
              <>
                <li>
                  <span className="mono">{"{{report_title}}"}</span> — the Atlas Report&apos;s name
                </li>
                <li>
                  <span className="mono">{"{{data_as_of}}"}</span> — the date the data was read
                </li>
                <li>
                  <span className="mono">{"{{version_note}}"}</span> — the author&apos;s change note, on the first delivery after a
                  new version is approved (empty otherwise)
                </li>
              </>
            ) : (
              <li>
                <span className="mono">{"{{page_title}}"}</span> — the page&apos;s title
              </li>
            )}
            <li>
              <span className="mono">{"{{fired_at}}"}</span> — when the report was generated (in tenant time)
            </li>
            <li>
              <span className="mono">{"{{recipient_name}}"}</span> — the recipient&apos;s display name (or local
              part of their email)
            </li>
            <li>
              <span className="mono">{"{{delivery_name}}"}</span> — this audience&apos;s name
            </li>
            <li>
              <span className="mono">{"{{owner_name}}"}</span> — the owner&apos;s display name
            </li>
            <li>
              <span className="mono">{"{{owner_email}}"}</span> — the owner&apos;s email address
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
}
